"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _plusSquare = _interopRequireDefault(require("@atlaskit/icon/core/plus-square"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IssueRaiseIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="11" y="9" rx="1"/><path fill-rule="nonzero" d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991M3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 15.991z"/><rect width="6" height="2" x="9" y="11" rx="1"/></g></svg>`
}, props, {
  newIcon: _plusSquare.default
}));
IssueRaiseIcon.displayName = 'IssueRaiseIcon';
var _default = exports.default = IssueRaiseIcon;